import { Grid } from '@material-ui/core';
import React from 'react';
import { styles } from './action-window-styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppState } from 'src/common/redux/configure-store';

const ActionWindowGrossWeightLine: React.FC<Props> = (props: Props): JSX.Element => {
  const { grossWeight, atomicMsuUnit } = props;
  const { t } = useTranslation();
  const precision = useSelector(
    (state: AppState) =>
      state.touchPoint.touchPointConfiguration.defaultWeightUnitOfMeasurePrecision,
  );
  const classes = styles({});
  return (
    <Grid
      className={`fullWidth ${classes.eligibilityContainer} ${classes.weightEntered}`}
      data-testid='action-window-eligibility-container'
    >
      {grossWeight.toFixed(precision)} {atomicMsuUnit} {t('TareGross')}
    </Grid>
  );
};

interface Props {
  grossWeight: number;
  atomicMsuUnit: string | undefined;
}

export default ActionWindowGrossWeightLine;
